/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */

export const isDigit = (value) => {
    if (typeof value !== 'string') {
        return false;
    }
    if (value.length !== 1) {
        return false;
    }
    return value >= '0' && value <= '9';
};

export const isCharacter = (value) => {
    if (typeof value !== 'string') {
        return false;
    }
    if (value.length !== 1) {
        return false;
    }
    value = value.toUpperCase();
    return value >= 'A' && value <= 'Z';
};

const getMaskInfo = (mask) => {
    const index = mask.indexOf('[');
    if (index < 0) {
        return [mask];
    }
    const endIndex = mask.indexOf(']');
    if (endIndex < 0) {
        return [mask];
    }
    return [mask.substring(0, index), mask.substring(index+1, endIndex)]; 
};


export const maskedFormatter = (maskFormat, input, backspace, upperCase) => {
    if (!maskFormat || maskFormat.length === 0 || !input || input.length === 0) {
        return input;
    }
    const [base, optional] = getMaskInfo(maskFormat);
    const mask = base + (optional ? optional : '');
    const cleanFilter = mask.replace(/[XNA]/g, '');
    input = input.replace(new RegExp(cleanFilter), '');

    let output = '';
    let index = 0;
    let code, len;
    for (let n = 0; n < mask.length; n++) {
        code = mask.charAt(n);
        len = output.length;
        if (code === 'X') {
            output += input.charAt(index) !== ' ' ? input.charAt(index++) : '';
        } else if (code === 'N') {
            output += isDigit(input.charAt(index)) ? input.charAt(index++) : '';
        } else if (code === 'A') {
            output += isCharacter(input.charAt(index)) ? input.charAt(index++) : '';
        } else {
            output += input.charAt(index) === code ? input.charAt(index++) : code;
        }
        if (output.length === len) {
            break;
        }
        if (index === input.length) {
            if (!backspace) {
                code = mask.charAt(n+1);
                if (code !== 'X' && code !== 'N' && code !== 'A' && (!optional || input.length !== base.length)) {
                    output += code;
                }
            }
            break;
        }
    }
    if (output.length > 0 && upperCase && (mask.includes('X') || mask.includes('A'))) {
        output = output.toUpperCase();
    }
    return output;
};

export const defaultPostalCodeFormatter = {
    pattern: '',
    mask: '',
    maxLength: 15,
    example: '',
    upperCase: false
};

